import { memberFetch } from './memberApi';

const readJson = async (response) => {
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.detail || 'Unable to load release notes.');
  return body;
};

export const getMemberReleaseNotes = async ({
  page = 1,
  perPage = 5,
  search = '',
  fromDate = '',
  toDate = '',
} = {}) => {
  const params = new URLSearchParams({ page: String(page), per_page: String(perPage) });
  if (search) params.set('search', search);
  if (fromDate) params.set('from_date', fromDate);
  if (toDate) params.set('to_date', toDate);
  return readJson(await memberFetch(`/api/customer/release-notes?${params}`));
};

export const markMemberReleaseNoteSeen = async (releaseNoteId) => readJson(
  await memberFetch('/api/customer/release-notes/seen', {
    method: 'PUT',
    body: JSON.stringify({ release_note_id: releaseNoteId }),
  }),
);
